import React, { useContext, useEffect, useState } from "react";
import { AppContext, checkMobile, SET_PHONE_ALL } from "./AppProvider";

// Utils
import { getCookie, setCookie, setCookies } from "../modules/utils/cookie";
import { resEvent, webRequest } from "../views/Nftf/Interface/NFTF/NativeApi";

// Assets

const PhoneInfoGenerator = ({ children }) => {
  const { phonecfg, dispatch, pageState } = useContext(AppContext);
  // 로컬 개발시 false
  const [isLoading, setIsLoading] = useState(true);
  const [cnt, setCnt] = useState(0);

  // const params = new URLSearchParams(window.location.search);

  const phoneInfoSettigLoop = () => {
    if (cnt < 10) {
      // GET_PHONE_INFO: { command: "100", data: "" },
      if (phonecfg.version === "2.0.0" || phonecfg.phoneToken === "123") {
        // socketManager(SocketCommand.GET_PHONE_INFO, undefined);
        setCnt(cnt + 1);
      } else {
        setCnt(999);
        setIsLoading(false);
      }
    } else {
      if (getCookie("phoneCfg")) {
        dispatch({ type: SET_PHONE_ALL, data: getCookie("phoneCfg") });
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    webRequest("phoneInfo", {});
  }, []);

  useEffect(() => {
    if (pageState.reload === 1) {
      setIsLoading(false);
    }

    if (isLoading) {
      phoneInfoSettigLoop();
    }
  }, [pageState.reload, cnt]);

  useEffect(() => {
    if (checkMobile() === "IOS") {
      if (isLoading) {
        if (
          getParameter("100") &&
          getParameter("100") != null &&
          getParameter("100") != "null" &&
          getParameter("100") != undefined &&
          getParameter("100") != ""
        ) {
          // 값이 null일때 처리추가
          setCookies(JSON.parse(getParameter("100")), 365);
          setCookie("phoneCfg", JSON.parse(getParameter("100")), 365);
          dispatch({
            type: SET_PHONE_ALL,
            data: JSON.parse(getParameter("100")),
          });
          setIsLoading(false);
        } else {
          phoneInfoSettigLoop();
        }

        webRequest("phoneInfo", "");
      }
    }
  }, [cnt, isLoading]);

  useEffect(() => {
    window.NativeInterface = {
      nativeResponse: value => {
        // nativeResponse(value);
        resEvent(value, dispatch);

        // setCookies(JSON.parse(value).data, 365);
        // setCookie("phoneCfg", JSON.parse(value).data, 365);
        // dispatch({
        //   type: SET_PHONE_ALL,
        //   data: JSON.parse(value).data,
        // });
        // setIsLoading(false);
      },
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <div style={{ whiteSpace: "pre-wrap" }}>
          {checkMobile() +
            " 단말기 정보를 불러오고 있습니다..." +
            "\n" +
            "버전: " +
            phonecfg.version +
            "\n" +
            "토큰: " +
            phonecfg.phoneToken +
            "\n" +
            "OS: " +
            phonecfg.phoneOS +
            "\n" +
            "리로드 카운트: " +
            cnt +
            "\n"}
        </div>
      ) : (
        // <Loading />
        children
      )}
    </>
  );
};

export const getParameter = key => {
  let returnValue = decodeURI(
    new URLSearchParams(window.location.search).get(key)
  );
  // returnValue = JSON.parse(returnValue);
  return returnValue;
};

export default PhoneInfoGenerator;
